/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecurringInvestmentViewModel
 */
export interface RecurringInvestmentViewModel {
    /**
     * 
     * @type {Date}
     * @memberof RecurringInvestmentViewModel
     */
    nextPaymentDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof RecurringInvestmentViewModel
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof RecurringInvestmentViewModel
     */
    frequency?: string;
}

/**
 * Check if a given object implements the RecurringInvestmentViewModel interface.
 */
export function instanceOfRecurringInvestmentViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RecurringInvestmentViewModelFromJSON(json: any): RecurringInvestmentViewModel {
    return RecurringInvestmentViewModelFromJSONTyped(json, false);
}

export function RecurringInvestmentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecurringInvestmentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nextPaymentDate': !exists(json, 'NextPaymentDate') ? undefined : (new Date(json['NextPaymentDate'])),
        'amount': !exists(json, 'Amount') ? undefined : json['Amount'],
        'frequency': !exists(json, 'Frequency') ? undefined : json['Frequency'],
    };
}

export function RecurringInvestmentViewModelToJSON(value?: RecurringInvestmentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'NextPaymentDate': value.nextPaymentDate === undefined ? undefined : (value.nextPaymentDate.toISOString()),
        'Amount': value.amount,
        'Frequency': value.frequency,
    };
}

